// generate standard list of years available as default in most calendar libraries. use react-calendar's list as a reference:

const yearsFilterOption = Array.from({ length: 121 }, (_, i) => {
  const year = new Date().getFullYear() - 100 + i;
  return { label: year.toString(), value: year.toString() };
}); 

export default yearsFilterOption